import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, Facility, PagedResponse, KinsideSearchParams, KinsideSearchInfo } from '../types';

const SEARCH_URL = '/v2/kinside/search';
const INTERNAL_SEARCH_URL = '/internal/kinside';
const SEARCH_INFO_URL = '/v2/kinside-search-infos';

class KinsideService {
  static async search(params: KinsideSearchParams): Promise<PagedResponse<Facility>> {
    const config: AxiosRequestConfig = { params };

    if (typeof window === 'undefined') {
      config.baseURL = `http://${process.env.US_SERVICES_HOST}:${process.env.US_SERVICES_PORT}`;
    }

    const response = await axios.get(SEARCH_URL, config);

    if (response.data?.error) {
      throw new Error(response.data.error);
    }

    return response;
  }

  static async searchInternal(params: KinsideSearchParams, requestConfig?: AxiosRequestConfig): Promise<PagedResponse<Facility>> {
    try {
      const config: AxiosRequestConfig = {
        params,
        ...requestConfig
      };

      if (typeof window === 'undefined') {
        config.baseURL = `http://${process.env.US_SERVICES_HOST}:${process.env.US_SERVICES_PORT}`;
      }

      const response = await axios.get(INTERNAL_SEARCH_URL, config);

      if (response.data?.error) {
        throw new Error(response.data.data.error);
      }

      return response;
    } catch {
      const emptyResponse: PagedResponse<Facility> = {
        data: {
          data: [],
          meta: {
            firstPage: true,
            lastPage: true,
            pageCount: 1,
            page: 1,
            size: 0,
          },
        },
      };

      return emptyResponse;
    }
  }

  static saveSearchInfo(data: KinsideSearchInfo, config?: AxiosRequestConfig): Promise<DataResponse<KinsideSearchInfo>> {
    const requestConfig = config || {};

    if (process.env.US_SERVICES_HOST && process.env.US_SERVICES_PORT) {
      requestConfig.baseURL = `http://${process.env.US_SERVICES_HOST}:${process.env.US_SERVICES_PORT}`;
    }

    return axios.post(SEARCH_INFO_URL, data, requestConfig);
  }
}

export { KinsideService };
